<template>
  <v-app>
    <membership v-if="status === 'incomplete'"></membership>
    <submitted v-if="status === 'submitted'"></submitted>
    <!-- <administration v-if="admin"></administration> -->
    <members v-if="admin"></members>
  </v-app>

</template>

<script>

// Store
import store from '../modules/store'

// Components
import Toolbar from './Toolbar'
import Membership from './Membership'
import Submitted from './Submitted'
import Administration from './Administration'
import Members from './Members'

export default {
  components: {
    'app-toolbar': Toolbar,
    'administration': Administration,
    'members': Members,
    'membership': Membership,
    'submitted': Submitted
  },
  data () {
    return {
      status: '',
      admin: false,
      store
    }
  },
  watch: {
    '$route.query': function () {
      if (this.store.user != null) {
        this.status = this.store.user.status
      }
    },
    'store.user.status': function () {
      this.status = this.store.user.status
      console.log('status changed')
    },
    'store.admin': function () {
      this.admin = this.store.admin
    }
  },
  beforeMount: function () {
    this.admin = this.store.admin
    // console.log(this.store.user)
    if (this.store.user != null) {
      this.status = this.store.user.status
    }
  }
}
</script>



// WEBPACK FOOTER //
// Main.vue?afcb253e